// extracted by mini-css-extract-plugin
export default {"img":"item_img__tsy7o","item":"item_item__58ODc"};